/* eslint-disable @typescript-eslint/ban-types */
import { FormControl } from '@material-ui/core'
import React from 'react'
import TextField from '@material-ui/core/TextField'
import { format } from '@flatsy/utils/Functions/DateTime/Datefns'
import { isValid } from 'date-fns'
import { useStyles } from './Style'
import { DateFieldProps } from './Type'

export const FlatsyDateField = ({
  label,
  onChange,
  value,
  error,
  name,
  disabled,
}: DateFieldProps): React.ReactElement => {
  const classes = useStyles()
  const date = format(new Date(), 'yyyy-MM-dd')

  const handleChange = (val: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (isValid(new Date(val.target.value))) {
      onChange(val.target.value)
    }
  }

  return (
    <FormControl
      component="fieldset"
      error={!!error?.message}
      name={name}
      key={name}
      className={classes.container}
    >
      <TextField
        type="date"
        onChange={handleChange}
        defaultValue={date}
        label={label}
        className={classes.date}
        InputLabelProps={{
          shrink: true,
        }}
        value={value || undefined}
        disabled={disabled}
      />
    </FormControl>
  )
}

export default FlatsyDateField
